import { Component, computed, input } from '@angular/core';
import { resolveCalloutColor } from '../../callout-colors';
import {
    parseTableValue,
    resolveTableStyle,
    resolveTableZebra,
    tableRowHasContent,
} from '../../table-options';

/**
 * Tabela só para LEITURA: lixeira, favoritos e a prévia antiga. Desenha como o PDF
 * (mesmos estilos e cores de `items/table.css`), pulando linhas vazias e o cabeçalho
 * quando nenhuma coluna tem nome.
 */
@Component({
    selector: 'table-view',
    templateUrl: 'table-view.component.html',
    styleUrl: 'table-view.component.scss',
})
export class TableViewComponent {
    /** `value` cru do item (`{ columns, rows }`). */
    public value = input<unknown>();
    public styleKey = input<string | null | undefined>();
    public zebra = input<boolean | null | undefined>();
    public color = input<string | null | undefined>();
    /** Mostra no máximo estas linhas (lixeira e favoritos); o resto vira "+N linhas". */
    public maxRows = input<number | null>(null);
    /** Tamanho próprio da letra (config textSize do item, em rem do editor), null = 11pt. */
    public textSize = input<string | null>(null);

    public table = computed(() => parseTableValue(this.value()));
    public hasHeader = computed(() => this.table().columns.some(c => !!c.trim()));
    public printableRows = computed(() => this.table().rows.filter(tableRowHasContent));
    public visibleRows = computed(() => {
        const max = this.maxRows();
        const rows = this.printableRows();
        return max ? rows.slice(0, max) : rows;
    });
    public hiddenRows = computed(() => this.printableRows().length - this.visibleRows().length);
    public tableClass = computed(
        () =>
            `table table-${resolveTableStyle(this.styleKey())}` +
            (resolveTableZebra(this.zebra()) ? ' table-zebra' : '')
    );
    public family = computed(() => resolveCalloutColor(this.color()));
}
